import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from 'antd';

const DATE_PLACEHOLDER_COUNT = 7;
const TIME_PLACEHOLDER_COUNT = 4;

const Label = () => <Skeleton.Input active size="small" className="spc-appointment-skeleton__label" />;
const Block = ({ className }) => <Skeleton.Button active block className={className} />;

Block.propTypes = {
  className: PropTypes.string.isRequired,
};

// Stands in for DesktopDateTimePicker / MobileDateTimePicker while CheckScheduleAppt is in
// flight. Reuses the pickers' own layout classes so the real picker drops into the same
// footprint once the appointment windows arrive.
const AppointmentSkeleton = ({ isMobile }) => (
  <div className="spc-appointment-skeleton" aria-busy="true">
    {isMobile ? (
      <div className="spc-mobile-date-time-picker">
        {['date', 'time'].map((field) => (
          <div className="spc-mobile-date-time-picker__field" key={field}>
            <Label />
            <Block className="spc-appointment-skeleton__field" />
          </div>
        ))}
        <Block className="spc-appointment-skeleton__field" />
      </div>
    ) : (
      <div className="spc-appointment-picker">
        <div className="spc-appointment-picker__row"><Label /></div>
        <div className="spc-date-grid">
          {Array.from({ length: DATE_PLACEHOLDER_COUNT }, (_, index) => (
            <Block key={`date-${index}`} className="spc-appointment-skeleton__date" />
          ))}
        </div>

        <div className="spc-appointment-picker__row"><Label /></div>
        <div className="spc-time-grid">
          {Array.from({ length: TIME_PLACEHOLDER_COUNT }, (_, index) => (
            <Block key={`time-${index}`} className="spc-appointment-skeleton__time" />
          ))}
        </div>

        <div className="spc-appointment-picker__actions">
          <Block className="spc-appointment-skeleton__action" />
        </div>
      </div>
    )}
  </div>
);

AppointmentSkeleton.propTypes = {
  isMobile: PropTypes.bool,
};

export default AppointmentSkeleton;
